import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  RouteRecordRaw,
} from "vue-router";
import { useTitle } from "@vueuse/core";
import Login from "@/views/Login.vue";
import { useSessionState, useState } from "@/store";
import { trackRouter } from "vue-gtag-next";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
    meta: {
      title: "Home",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: "Login",
    },
  },
  {
    path: "/competency",
    name: "competencyList",
    meta: {
      title: "Competency",
    },
    component: () => import("../views/master/Competency.vue"),
  },
  {
    path: "/skill",
    name: "skillList",
    meta: {
      title: "Skill",
    },
    component: () => import("../views/master/Skill.vue"),
  },
  {
    path: "/course",
    name: "courseList",
    meta: {
      title: "Course",
    },
    component: () => import("../views/master/Course.vue"),
  },
  {
    path: "/coursetype",
    name: "courseType",
    meta: {
      title: "CourseType",
    },
    component: () => import("../views/master/CourseType.vue"),
  },
  {
    path: "/instructor",
    name: "instructor",
    meta: {
      title: "instructor",
    },
    component: () => import("../views/master/Instructor.vue"),
  },
  {
    path: "/compentencyassessment",
    name: "compentencyAssessment",
    meta: {
      title: "Compentensy Assessment",
    },
    component: () => import("../views/master/CompentencyAssessment.vue"),
  },
  {
    path: "/courseMaintain/new",
    name: "newCourse",
    meta: {
      title: "New Course",
    },
    component: () => import("../views/master/CourseMaintain.vue"),
  },
  {
    path: "/courseMaintain/:id",
    name: "editCourse",
    meta: {
      title: "Edit Course",
    },
    component: () => import("../views/master/CourseMaintain.vue"),
  },
  {
    path: "/trainingDocumentMaintain/:docNo",
    name: "editTrainingDocument",
    meta: {
      title: "Edit Training Document",
    },
    component: () => import("../views/master/TrainingDocumentMaintain.vue"),
  },
  {
    path: "/trainingDocumentMaintain/:id/new",
    name: "newTrainingDocument",
    meta: {
      title: "New Training Document",
    },
    component: () => import("../views/master/TrainingDocumentMaintain.vue"),
  },
  // {
  //   path: "/internalTrainingForm/:docNo/:employeeId",
  //   name: "internalTrainingForm",
  //   meta: {
  //     title: "Internal Training Form",
  //   },
  //   component: () => import("../views/master/InternalTrainingForm.vue"),
  // },
  {
    path: "/employees",
    name: "employees",
    meta: {
      title: "พนักงาน",
    },
    component: () => import("../views/master/Employee.vue"),
  },
  {
    path: "/questions",
    name: "questions",
    meta: {
      title: "แบบประเมิน",
    },
    component: () => import("../views/master/QuestionList.vue"),
  },
  {
    path: "/question/new",
    name: "newQuestion",
    meta: {
      title: "สร้างแบบประเมินใหม่",
    },
    component: () => import("../views/master/QuestionScreen.vue"),
  },
  {
    path: "/question/:id",
    name: "editQuestion",
    meta: {
      title: "แก้ไขแบบประเมิน",
    },
    component: () => import("../views/master/QuestionScreen.vue"),
  },
  // {
  //   path: "/training/assessment/:documentId",
  //   name: "performTrainingAssessment",
  //   meta: {
  //     title: "แบบประเมิน",
  //   },
  //   component: () =>
  //     import("../views/transactions/TrainingAssessmentScreen.vue"),
  // },
  // {
  //   path: "/training/assessment/:documentId/:employeeId",
  //   name: "viewTrainingAssessment",
  //   meta: {
  //     title: "แบบประเมิน",
  //   },
  //   component: () =>
  //     import("../views/transactions/TrainingAssessmentScreen.vue"),
  // },
  {
    path: "/training/assessment/:documentId/:questionId",
    name: "performAssessment",
    meta: {
      title: "แบบประเมิน",
    },
    component: () => import("../views/transactions/AssessmentScreen.vue"),
  },
  {
    path: "/training/assessment/:documentId/:questionId/:employeeId",
    name: "viewAssessment",
    meta: {
      title: "แบบประเมิน",
    },
    component: () => import("../views/transactions/AssessmentScreen.vue"),
  },
  // {
  //   path: "/training/assessment/:documentId/:employeeId",
  //   name: "editTrainingAssessment",
  //   meta: {
  //     title: "แบบประเมิน",
  //   },
  //   component: () =>
  //     import("../views/transactions/TrainingAssessmentScreen.vue"),
  // },
  {
    path: "/positionList",
    name: "positionList",
    meta: {
      title: "แบบประเมินพนักงานใหม่ / ย้ายแผนก / เลื่อนตำแหน่ง",
    },
    component: () => import("../views/transactions/PositionDocumentList.vue"),
  },
  {
    path: "/positionDocument/create",
    name: "createPositionDocument",
    meta: {
      title: "แบบประเมินพนักงานใหม่ / ย้ายแผนก / เลื่อนตำแหน่ง",
    },
    component: () => import("../views/transactions/PositionDocumentCreate.vue"),
  },
  {
    path: "/positionDocument/:id",
    name: "editPositionDocument",
    meta: {
      title: "แบบประเมินพนักงานใหม่ / ย้ายแผนก / เลื่อนตำแหน่ง",
    },
    component: () => import("../views/transactions/PositionDocumentCreate.vue"),
  },
  {
    path: "/menu",
    name: "menu",
    meta: {
      title: "Menu หลัก",
    },
    component: () => import("../views/GrandMenu.vue"),
  },
  {
    path: "/trainingDocumentList",
    name: "trainingDocumentList",
    meta: {
      title: "เอกสารการฝึกอบรม",
    },
    component: () =>
      import("../views/transactions/TrainingDocumentListScreen.vue"),
  },
  {
    path: "/position/assessment/:id",
    name: "positionAssessment",
    meta: {
      title: "แบบประเมินพนักงานใหม่/ ย้ายแผนก / เลื่อนตำแหน่ง",
    },
    component: () =>
      import("../views/transactions/PositionDocumentAssessment.vue"),
  },
  {
    path: "/config/pdpa",
    name: "configPdpa",
    meta: {
      title: "ระบุ PDPA",
    },
    component: () => import("../views/config/ConfigPdpaScreen.vue"),
  },
  {
    path: "/config/user",
    name: "configUser",
    meta: {
      title: "แก้ไขสิทธิการใช้งานระบบ",
    },
    component: () => import("../views/config/ConfigUserScreen.vue"),
  },
  {
    path: "/config/questionSets",
    name: "configQuestionSet",
    meta: {
      title: "ตั้งค่าชุดแบบประเมิน และวันที่ติดตาม",
    },
    component: () => import("../views/config/ConfigQuestionSetScreen.vue"),
  },
  {
    path: "/pdpa",
    name: "pdpa",
    meta: {
      title: "นโยบายความเป็นส่วนตัว",
    },
    component: () => import("../views/PdpaScreen.vue"),
  },
  {
    path: "/onthejob/list",
    name: "onTheJobList",
    meta: {
      title: "เอกสารอบรมต้นสังกัด - On The Job",
    },
    component: () => import("../views/transactions/OnTheJobDocumentList.vue"),
  },
  {
    path: "/onthejob/create",
    name: "createOnTheJobDocument",
    meta: {
      title: "เอกสารอบรมต้นสังกัด - On The Job",
    },
    component: () => import("../views/transactions/OnTheJobDocumentScreen.vue"),
  },
  {
    path: "/onthejob/edit/:id",
    name: "editOnTheJobDocument",
    meta: {
      title: "เอกสารอบรมต้นสังกัด - On The Job",
    },
    component: () => import("../views/transactions/OnTheJobDocumentScreen.vue"),
  },
  {
    path: "/courseRelationList",
    name: "courseRelationList",
    meta: {
      title: "ความสัมพันธ์ระหว่างตำแหน่งและหลักสูตรการฝึกอบรม",
    },
    component: () => import("../views/master/CourseRelationList.vue"),
  },
  {
    path: "/agingReport",
    name: "agingReport",
    meta: {
      title: "รายงานอายุเอกสาร",
    },
    component: () => import("../views/report/AgingReport.vue"),
  },
  {
    path: "/trainingReport",
    name: "trainingReport",
    meta: {
      title: "รายงานรายละเอียดการฝึกอบรม",
    },
    component: () => import("../views/report/TrainingReport.vue"),
  },
  {
    path: "/employee/:id",
    name: "employee",
    meta: {
      title: "รายละเอียดพนักงาน",
    },
    component: () => import("../views/master/EmployeeScreen.vue"),
  },
  {
    path: "/configParameter",
    name: "configParameter",
    meta: {
      title: "ตั้งค่าอื่น ๆ",
    },
    component: () => import("../views/config/ConfigParameterScreen.vue"),
  },
  {
    path: "/notificationLogs",
    name: "notificationLogs",
    meta: {
      title: "ประวัติการแจ้งเตือน",
    },
    component: () => import("../views/report/NotificationLog.vue"),
  },
  {
    path: "/test",
    name: "Test",
    meta: {
      title: "Test",
    },
    component: () => import("../views/Test.vue"),
  },
  {
    path: "/underConstruction",
    name: "underConstruction",
    meta: {
      title: "UnderConstruction",
    },
    component: () => import("../views/UnderConstruction.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const adminOnly = ["menu"];

const state = useState();
const sessionState = useSessionState();

router.beforeEach(async function(to, _, next) {
  if (state.value.authentication.token === "" && to.name !== "login") {
    next({ name: "login" });
    return;
  } else if (state.value.authentication.token !== "") {
    if (
      sessionState.value.profile.isPdpaAccepted !== true &&
      to.name !== "pdpa"
    ) {
      next({ name: "pdpa" });
      return;
    }
    if (
      adminOnly.indexOf(to.name as string) >= 0 &&
      sessionState.value.profile.isAdmin !== true
    ) {
      next({ name: "home" });
      return;
    }
    if (to.name === "login") {
      next({ name: sessionState.value.profile.isAdmin ? "menu" : "home" });
      return;
    }
    next();
    return;
  } else {
    window.scrollTo(0, 0);
    next();
    return;
  }
});

router.beforeResolve((to) => {
  // useGtag().pageview(to.meta.tile ?? "N/A");
  const prefix = `HRD Smart :: ${state.value.authentication.username}`;
  useTitle(`${prefix} :: ${to.meta.title ?? prefix}`);
});

//Vue gtag router
trackRouter(router);

export default router;
